// extracted by mini-css-extract-plugin
export default {"signupHeader":"signupHeader-HaxbT","signupHeaderTitle":"signupHeaderTitle-hvGtp","firstTextLine":"firstTextLine-M25fN","secondTextLine":"secondTextLine-mBJmO"};